<template>
  <div class="home">
    <div class="p-2 md:p-0">
      <ParticipantsDisplay />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { participantsModule } from "@/store/modules/participants";
import { pageManagerModule } from "@/store/modules/pageManager";
import ParticipantsDisplay from "@/components/participants/ParticipantsDisplay.vue";

export default defineComponent({
  name: "Home",
  components: { ParticipantsDisplay },
  async beforeMount() {
    await participantsModule.fetchParticipants();
  },
  computed: {
    participants() {
      return participantsModule.participants;
    }
  },
  beforeRouteEnter() {
    pageManagerModule.changePageTitle("Home");
  }
});
</script>

<style scoped>
.link {
  @apply text-blue-500 mb-2;
}

.link:hover {
  @apply text-blue-400;
}
</style>
